import React from "react";
import { useLocation } from "react-router-dom";
import Hamburger from "hamburger-react";

const Header = ({ isOpen, setOpen }) => {
  const location = useLocation();
  const [pageTitle, setPageTitle] = React.useState("");

  const getPageTitle = (path) => {
    switch (path) {
      case "/admin/dashboard":
        return "Dashboard | Admin";
      case "/admin/dashboard/products":
        return "Our Products | Admin";
      case "/admin/dashboard/addproduct":
        return "Add Product | Admin";
      case "/admin/dashboard/editproduct":
        return "Edit Product | Admin";
      case "/admin/dashboard/interests":
        return "Interests | Admin";
      case "/admin/dashboard/detailInterest":
        return "Interest Detail | Admin";
      case "/admin/dashboard/customers":
        return "AGA Customers | Admin";
      default:
        return "Admin Panel";
    }
  };

  React.useEffect(() => {
    const newPageTitle = getPageTitle(location.pathname);
    setPageTitle(newPageTitle);
    document.title = newPageTitle;
  }, [location]);
  return (
    <div className="dashboard-header h-20 flex items-center p-5 text-md bg-[#f9f9f9] shadow-md">
      {pageTitle}

      <div className="hamburger-icon">
        <Hamburger toggled={isOpen} toggle={setOpen} />
      </div>
    </div>
  );
};

export default Header;
